var map = {
	"./help-desk/help-desk.module": [
		"./src/app/pages/help-desk/help-desk.module.ts",
		"default~help-desk-help-desk-module~lotto-lotto-module~pages-pages-module~payment-payment-module~priz~4c255438",
		"default~help-desk-help-desk-module~lotto-lotto-module~prize-prize-module",
		"help-desk-help-desk-module"
	],
	"./lotto/lotto.module": [
		"./src/app/pages/lotto/lotto.module.ts",
		"default~help-desk-help-desk-module~lotto-lotto-module~pages-pages-module~payment-payment-module~priz~4c255438",
		"default~help-desk-help-desk-module~lotto-lotto-module~prize-prize-module",
		"common",
		"lotto-lotto-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"default~help-desk-help-desk-module~lotto-lotto-module~pages-pages-module~payment-payment-module~priz~4c255438",
		"common",
		"pages-pages-module"
	],
	"./payment/payment.module": [
		"./src/app/pages/payment/payment.module.ts",
		"default~help-desk-help-desk-module~lotto-lotto-module~pages-pages-module~payment-payment-module~priz~4c255438",
		"common",
		"payment-payment-module"
	],
	"./prize/prize.module": [
		"./src/app/pages/prize/prize.module.ts",
		"default~help-desk-help-desk-module~lotto-lotto-module~pages-pages-module~payment-payment-module~priz~4c255438",
		"default~help-desk-help-desk-module~lotto-lotto-module~prize-prize-module",
		"common",
		"prize-prize-module"
	],
	"./widgets/widgets.module": [
		"./src/app/widgets/widgets.module.ts",
		"default~help-desk-help-desk-module~lotto-lotto-module~pages-pages-module~payment-payment-module~priz~4c255438",
		"widgets-widgets-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;